var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.cmsBlocks),function(cmsBlock){return _c('div',{key:cmsBlock.__typename + cmsBlock.id},[_c(_vm.componentMap[cmsBlock.__typename],{tag:"component",attrs:{"cmsBlock":cmsBlock}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }